import React from 'react'
import { Link } from 'react-router-dom'
import {
  Box,
  Snackbar,
  TextField,
  Button,
  ListItem,
  List,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import API from '@aws-amplify/api'
import { useDispatch, useSelector } from 'react-redux'
import { IProduction, Production } from 'interfaces/IProduction'
import {
  STOCK_CARD_TYPE_PREMIX,
} from 'enums/stockCard'
import LoadPremixAutocomplete from 'shared/autocomplete/loadPremixAutocomplete'
import { IReduxState } from 'interfaces/IReduxState'

export default function AddProductionPremix() {
  const type = STOCK_CARD_TYPE_PREMIX
  const [productionData, setProductionData] = React.useState<IProduction>(
    new Production({})
  )
  const [premixDepartment, setPremixDepartment] = React.useState<string>(
    'KOSMETIK'
  )
  const [isFailureSnackbarOpen, setIsFailureSnackbarOpen] =
    React.useState(false)
  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] =
    React.useState(false)
  const [isLoading, setIsLoading] = React.useState<any>(false)
  const [alertMessage, setAlertMessage] = React.useState('')
  const user = useSelector((state: IReduxState) => state.currentUser || {})

  const handleSnackbarClose = (): void => {
    setIsFailureSnackbarOpen(false)
    setIsSuccessSnackbarOpen(false)
  }

  const handleProductionFieldChange = (value: any, key: string): void => {
    setProductionData((prev) => ({ ...prev, [key]: value }))
  }

  const saveProduction = (e: React.SyntheticEvent): void => {
    e.preventDefault()
    setIsLoading(true)
    const displayType = 'Ruahan'

    const batches: any[] = []

    API.post('products', `/production/createProduction`, {
      body: { ...productionData, type, batches },
    })
      .then((response) => {
        setAlertMessage(`Berhasil menambah permintaan ${displayType}`)
        setIsSuccessSnackbarOpen(true)
        setProductionData(new Production({}))
      })
      .catch((error) => {
        const resp = (error as any)?.response
        if (resp && resp.data && resp.data.error) {
          setAlertMessage(
            `Gagal menambah permintaan ${displayType}: ${resp.data.error}`
          )
        } else {
          setAlertMessage(`Gagal menambah permintaan ${displayType}.`)
        }

        setIsFailureSnackbarOpen(true)
        console.error(resp || error)
      })
      .finally(() => {
        setIsLoading(false)
        window.location.reload()
      })
  }

  const dispatch = useDispatch()
  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_TITLE', payload: 'Buat Permintaan Ruahan' })
  }, [dispatch])

  const getValidationErrors = () => {
    const errors: string[] = []

    if (!productionData.premixId) errors.push('Ruahan wajib dipilih')
    if (
      !productionData.premixQuantity ||
      Number(productionData.premixQuantity) <= 0
    )
      errors.push('Jumlah Ruahan harus > 0')


    return errors
  }

  const isAllFieldsComplete = () => {
    return getValidationErrors().length === 0
  }

  return (
    <Box>
      <Box mb={2}>
        <Button
          component={Link}
          to={`/production/manageProductionFormPremix/${premixDepartment?.toLowerCase() || 'kosmetik'}`}
          variant="outlined"
          color="primary"
        >
          Ke Daftar Permintaan Bikin Ruahan (PBOS)
        </Button>
      </Box>
      <Box>
        <Paper>
          <List>
            <>
              <ListItem>
                <LoadPremixAutocomplete
                  name={productionData.premixId}
                  onChange={(e) => {
                    handleProductionFieldChange(e?.premixId ?? '', 'premixId')
                    handleProductionFieldChange([], 'batches')
                    setPremixDepartment(e?.department ?? 'kosmetik')
                  }}
                />
              </ListItem>
              <ListItem>
                <TextField
                  required
                  autoComplete="off"
                  variant="outlined"
                  fullWidth
                  type="number"
                  label="qty yang diperlukan (kg or pcs)"
                  value={productionData.premixQuantity ?? ''}
                  onChange={(e) =>
                    handleProductionFieldChange(
                      e.target.value,
                      'premixQuantity'
                    )
                  }
                />{' '}
              </ListItem>

            </>
            <ListItem>
              <TextField
                fullWidth
                label="Notes"
                value={productionData.notes}
                onChange={(e) =>
                  handleProductionFieldChange(e.target.value, 'notes')
                }
              />
            </ListItem>
            <ListItem>
              <Typography>Requested By: {user.username}</Typography>
            </ListItem>
          </List>
        </Paper>
        {isLoading && (
          <Box p={3}>
            <CircularProgress />
          </Box>
        )}
        <React.Fragment>
          <Box mt={3} />
        </React.Fragment>
        <Paper>
          <Box p={2} mt={3}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={!isAllFieldsComplete() || isLoading}
              onClick={saveProduction}
            >
              Save
            </Button>
            {!isAllFieldsComplete() && (
              <Box mt={1}>
                {getValidationErrors().map((err) => (
                  <Typography
                    key={err}
                    variant="caption"
                    color="error"
                    display="block"
                  >
                    • {err}
                  </Typography>
                ))}
              </Box>
            )}
          </Box>
        </Paper>
      </Box>
      <React.Fragment>
        <Box mt={3} />
      </React.Fragment>
      <Snackbar
        open={isSuccessSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="success" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={isFailureSnackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert severity="error" elevation={6} variant="filled">
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  )
}
